import { render, staticRenderFns } from "./NovaTelaDeTitulos.vue?vue&type=template&id=0ffeb177&scoped=true&"
import script from "./NovaTelaDeTitulos.vue?vue&type=script&lang=ts&"
export * from "./NovaTelaDeTitulos.vue?vue&type=script&lang=ts&"
import style0 from "./NovaTelaDeTitulos.vue?vue&type=style&index=0&id=0ffeb177&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffeb177",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCard,VCol,VContainer,VForm,VIcon,VRow,VSpeedDial,VTooltip})
